import $ from 'jquery'

$(document).on("turbolinks:load", function() {
  $("#aluminium_tags").select2({
    multiple: true,
    tags: true,
    tokenSeparators: [',']
  });
});
